<template>
  <div class="navmenu">
    <ul class="navmnu_item">
      <!--  实训模拟  -->
      <li
        v-for="item in list"
        ref="lidom"
        @click="item.meta.id == 5 || item.meta.id == 4 ? '' : toPage(item)"
        :key="item.meta.id"
        @mouseover="handleShow(item.meta.id)"
        v-on:mouseout="handleHide"
      >
        <span :class="item.meta.id == id ? 'bluetext' : ''">{{
          item.meta.text
        }}</span>
        <!-- 二级路由 -->
        <!-- v-show:只有一级和二级路由id相等 且 鼠标悬浮该一级路由-->
        <div class="subtl">
          <div
            v-for="(c, cindex) in childlist"
            v-show="curid == c.meta.id && c.meta.id == item.meta.id"
            :key="cindex"
            @mouseover="c_indexhandleShow(cindex)"
            v-on:mouseout="c_indexhandleHide"
            :class="
              cindex == cur_cindex || $store.state.path == c.path
                ? 'submetatext'
                : ''
            "
            @click="childtoPage(c)"
          >
            {{ c.meta.text }}
          </div>
        </div>
      </li>
      <div :style="{ left: left, width: width }" class="bottomborder"></div>
      <div class="regest_login">
        <img src="../image/lr.png" alt="" />
        <p v-if="!$store.state.WebLoginuser">
          <span @click="login">登录</span
          >&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;<span
            @click="regest"
            >注册</span
          >
        </p>
        <div v-else class="webname">
          <p>
            <span>{{ $store.state.WebLoginuser.name }}</span>
          </p>
          <div class="subtl subtt">
            <div
              @click="touserinfo('0')"
              :class="$store.state.userinfo_tab == '0' ? 'submetatext' : ''"
            >
              账号资料
            </div>
            <div
              @click="touserinfo('1')"
              :class="$store.state.userinfo_tab == '1' ? 'submetatext' : ''"
              id="lastLinew"
            >
              我的课程
            </div>
            <div @click="exituserinfo" class="exitinfo">
              <span>退出登录</span>
            </div>
          </div>
        </div>
      </div>

      <div @click="console" class="regest_login">
        <img src="../image/kongz.png" />
        <span>控制台</span>
      </div>
    </ul>

    <!-- <div
      class="secondNav"
      v-for="item in child_list"
      :key="item.meta.id"
     v-on:mouseout="handleHide"
    >
      <router-link
        :to="item.path"
        v-if="item.meta.id == cur"
        class="secondRte"
       
        >{{ item.meta.text }}</router-link
      >
    </div> -->
  </div>
</template>

<script>
import router from "../router/index";
export default {
  name: "Vue2TemplateNavmenu",
  data() {
    return {
      // 弹窗展示
      popshow: false,
      domwidth: 0,
      reflist: [],
      data: [],
      cur: null,
      //鼠标悬浮事件：一级路由获取id,用来判断一级路由和二级路由id相等才展开二级
      curid: 0,
      cur_cindex: "111",
    };
  },

  mounted() {
    this.reflist = this.$refs.lidom;
    this.domwidth = Number(
      getComputedStyle(this.$refs.lidom[0]).width.split("p")[0]
    );
    router.push({ path: this.path });
  },
  watch: {},
  computed: {
    path: {
      get() {
        return this.$store.state.path;
      },
      set(newv) {
        return newv;
      },
    },
    id: {
      get() {
        return this.$store.state.id;
      },
      set(newv) {
        return newv;
      },
    },
    list: function () {
      return router.options.routes.filter((item) => {
        return item.meta && !item.meta.type;
      });
    },
    // 二级路由计算属性
    childlist: function () {
      return router.options.routes.filter((item) => {
        return item.meta.type == "child";
      });
    },

    left: function () {
      if (this.$store.state.id != undefined) {
        var domwidth = 0;
        if (this.reflist.length > 0) {
          this.reflist.forEach((item, index) => {
            if (index < this.$store.state.id) {
              domwidth +=
                Number(getComputedStyle(item).width.split("p")[0]) + 40;
            }
          });
          return domwidth + 20 + "px";
        }
      }
    },
    width: function () {
      if (this.$store.state.id != undefined) {
        var width;
        if (this.reflist.length > 0) {
          width =
            getComputedStyle(this.reflist[this.$store.state.id]).width.split(
              "p"
            )[0] + "px";
          return width;
        }
      }
    },
    data1: function () {
      return this.$store.state.userinfo_tab;
    },
  },
  watch: {
    // computed:data1和watch data1连用：试试响应userinfo_tab变化。解决在顶部导航栏点击更改userinfo_tab不变的问题
    data1: {
      handler(n, m) {
        this.$store.state.userinfo_tab = n;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    exituserinfo() {
      this.$store.state.WebLoginuser = "";
      this.$store.state.userinfo_tab = "0";
    },
    console() {
      window.open("http://3d.sanweiquan.cn/education/console/#/login");
    },
    login() {
      this.$emit("login");
    },
    regest() {
      this.$emit("regest");
    },
    childtoPage(item) {
      this.domwidth =
        Number(
          getComputedStyle(this.$refs.lidom[item.meta.id]).width.split("p")[0]
        ) + 40;
      this.path = item.path;
      this.$store.commit("CHANGE_PAGE", item.path);
      router.push({ path: item.path });
    },
    toPage(item) {
      this.domwidth =
        Number(
          getComputedStyle(this.$refs.lidom[item.meta.id]).width.split("p")[0]
        ) + 40;
      this.path = item.path;
      this.$store.commit("CHANGE_PAGE", item.path);
      router.push({ path: item.path });
    },

    handleShow(id) {
      // this.cur = true;
      this.curid = id;
    },
    handleHide: function () {
      // this.cur = !this.cur;
      this.curid = 0;
    },
    // 二级路由鼠标悬浮 添加动态类名
    c_indexhandleShow(index) {
      this.cur_cindex = index;
    },
    c_indexhandleHide() {
      this.cur_cindex = "111";
    },
    //
    touserinfo(i) {
      this.$router.push({
        path: "/userinfo",
      });
      this.$store.state.userinfo_tab = i;
    },
  },
};
</script>

<style>
#lastLinew {
  position: relative;
}
#lastLinew::after {
  content: "";
  display: block;
  width: 60%;
  height: 1px;
  background: #d6d6d6;
  position: absolute;
  top: 30px;
  left: 20px;
}

.webname:hover .subtt {
  display: block;
}
.subtt {
  display: none;
}
.exitinfo:hover span {
  color: #047ac6;
}
.console {
  padding-left: 20px;
}
.regest_login {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 20px;
  position: relative;
}
.regest_login span:hover {
  color: #047ac6;
}
.regest_login:last-child {
  margin-left: 30px;
}
.regest_login img {
  width: 18px;
  margin-right: 10px;
}
.submetatext {
  color: #047ac6;
}
.subtl {
  font-size: 14px;
  font-weight: 400;
  position: absolute;
  top: 60px;
  left: -20px;
  z-index: 111111;
  color: #333;
  width: 110px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  opacity: 0.96;
}
.subtl div {
  height: 19px;
  margin: 23px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.navmenu {
  font-size: 16px;
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
}
.navmenu .navmnu_item {
  position: relative;
  height: 60px;
  list-style: none;
  display: flex;
  /* justify-content: flex-end; */
  padding: 0;
  flex-wrap: nowrap;
  white-space: nowrap;
}
.navmnu_item li {
  position: relative;
  margin: 0 20px;
  box-sizing: border-box;
  cursor: pointer;
  transition: 0.3s;
  font-size: 16px;
}
.navmnu_item li:hover {
  font-weight: bold;
  color: #047ac6;
}
.lidom:hover .zi {
  width: 100%;
  height: 40px;
  display: block;
}
.navmnu_item li:last-child {
  margin-right: 0px;
}
.bluetext {
  font-weight: bold;
  color: #047ac6 !important;
}
.bottomborder {
  position: absolute;
  top: 50px;
  /* left: 0;
  width: 74px; */
  transition: 0.3s;
  border-bottom: 3px solid #047ac6;
  font-weight: bold;
}

/* 二级导航栏样式 */
.secondNav {
  position: relative;
  background: #eee;
}
.secondRte {
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 600px;
  /* top: 50px; */
  z-index: 33;
  text-decoration: none;
  background: #eee;
}
</style>